import React, { useMemo, useEffect } from 'react';
import { Grid, Paper, Card, CardContent, Typography, Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';
import { use } from 'react';

const StyledTableCell = withStyles(() => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

const TripViolation = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                return {
                    vehicle: item.assetName,
                    route: item.routeName || item.route,
                    tripDate: item.tripDate ? moment(item.tripDate).format('D-MMM YY hh:mm A') : '',
                    rule: item.rule || item.violationName || item.violationCode || '',
                    limits: item.limits ?? '',
                    violation: item.violation ?? '',
                    startTime: item.startTime ? moment(item.startTime).format('D-MMM YY hh:mm A') : '',
                    duration: item.duration ?? '',
                    eventDistance: item.eventDistance ?? '',
                    location: item.location,
                };
            });
        }
        return [];
    }, [reportData]);

    const tableColumns = useMemo(() => {
        return [
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Route', accessor: 'route' },
            { Header: 'Trip Date', accessor: 'tripDate' },
            { Header: 'Rule', accessor: 'rule' },
            { Header: 'Limits', accessor: 'limits' },
            { Header: 'Violation', accessor: 'violation' },
            { Header: 'Start Time', accessor: 'startTime' },
            { Header: 'Duration', accessor: 'duration' },
            { Header: 'Movement', accessor: 'eventDistance' },
            { Header: 'Location', accessor: 'location' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });

    useEffect(() => {
        if(reportData && reportData.reportRecords && reportData.reportRecords.length > 0){
            console.log("Trip Violation Report Data:", reportData.reportRecords);
        }
     }, [reportData]);

    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item container sm={12}>
                            <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                    <Divider />
                                    <br />
                                    <Grid container>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                From
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {reportData.reqBody?.timeFrom ? `${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}` : '-'}
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                To
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {reportData.reqBody?.timeTo ? `${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}` : '-'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item sm={12} container>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    }
    return null;
};

export default TripViolation;
